export const ENUM_MAPS = {
  alcohol_use_frequency: {
    Daily: "Daily",
    Weekly: "Weekly",
    Occasionally: "Occasionally",
    Never: "Never",
    "Prefer not to say": null, 
  },

  diet_type: {
    Vegetarian: "Vegetarian",
    Vegan: "Vegan",
    Omnivore: "Omnivore",
    Pescatarian: "Pescatarian",
    Other: "Other",
    "Prefer not to say": null,
  },

  ethnicity: {
    "Hispanic or Latino": "Hispanic or Latino",
    "Not Hispanic or Latino": "Not Hispanic or Latino",
    "Prefer not to say": null,
  },

  gender: {
    Male: "Male",
    Female: "Female",
    "Non-binary": "Non-binary",
    Other: "Other",
    "Prefer not to say": null,
  },

  race: {
    Caucasian: "Caucasian",
    Asian: "Asian",
    "African American": "African American",
    Hispanic: "Hispanic",
    "Native American": "Native American",
    "Native Alaskan": "Native Alaskan",
    "Native Hawaiian": "Native Hawaiian",
    Multiracial: "Multiracial",
    Other: "Other",
    Unknown: "Unknown",
    "Prefer not to say": null,
  },

  smoker_status: {
    Smoker: "Smoker",
    "Non-Smoker": "Non-Smoker",
    "Former Smoker": "Former Smoker",
    "Prefer not to say": null,
  },

  stress_level: {
    Low: "Low",
    Moderate: "Moderate",
    High: "High",
    "Very High": "Very High",
    "Prefer not to say": null,
  },

  title: {
    Mr: "Mr",
    Mrs: "Mrs",
    Ms: "Ms",
    Miss: "Miss",
    Dr: "Dr",
    Prof: "Prof",
    Rev: "Rev",
    Hon: "Hon",
    Sir: "Sir",
    Lady: "Lady",
    Capt: "Capt",
    Col: "Col",
    Maj: "Maj",
    Lt: "Lt",
    Adm: "Adm",
    Gen: "Gen",
    Mx: "Mx",
  },

  phone_type: {
    Mobile: "Mobile",
    Home: "Home",
    Work: "Work",
    Other: "Other",
  },

  best_days_to_call: {
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    "Any day": "Any day",
  },
};

export const normalizeEnum = (value, enumMap) => {
  if (value === undefined || value === null) return null;
  return enumMap[value] ?? null;
};


export function sanitizeMedicalSections(source) {
  const sanitized = {};

  /* =========================
     SUBJECT PHYSICIANS
  ========================= */
  if (Array.isArray(source.subject_physicians)) {
    sanitized.subject_physicians = source.subject_physicians.map(
      ({
        address_line1,
        address_line2,
        city,
        country,
        fax_number,
        id,
        last_exam_date,
        name,
        phone_number,
        postal_code,
        primary,
        provider_type,
        state,
        subject_id,
      }) => ({
        address_line1,
        address_line2,
        city,
        country,
        fax_number,
        id,
        last_exam_date,
        name,
        phone_number,
        postal_code,
        primary,
        provider_type,
        state,
        subject_id,
      })
    );
  }

  /* =========================
     MEDICAL HISTORY
  ========================= */
  if (Array.isArray(source.subject_medical_history)) {
    sanitized.subject_medical_history = source.subject_medical_history.map(
      ({
        condition_id,
        condition_name,
        condition_status,
        diagnosed_date,
        resolved_date,
        id,
        notes,
        subject_id,
      }) => ({
        condition_id,
        condition_name,
        condition_status,
        diagnosed_date,
        resolved_date,
        id,
        notes,
        subject_id,
      })
    );
  }

  /* =========================
     FAMILY MEDICAL HISTORY
  ========================= */
  if (Array.isArray(source.subject_family_medical_history)) {
    sanitized.subject_family_medical_history =
      source.subject_family_medical_history.map(
        ({
          condition_id,
          condition_name,
          family_member,
          id,
          notes,
          subject_id,
        }) => ({
          condition_id,
          condition_name,
          family_member,
          id,
          notes,
          subject_id,
        })
      );
  }

  /* =========================
     ALLERGIES
  ========================= */
  if (Array.isArray(source.subject_allergies)) {
    sanitized.subject_allergies = source.subject_allergies.map(
      ({
        allergy_id,
        allergy_name,
        allergy_type,
        id,
        notes,
        reaction,
        severity,
        subject_id,
      }) => ({
        allergy_id,
        allergy_name,
        allergy_type,
        id,
        notes,
        reaction,
        severity,
        subject_id,
      })
    );
  }

  /* =========================
     MEDICATIONS
  ========================= */
  if (Array.isArray(source.subject_medications)) {
    sanitized.subject_medications = source.subject_medications.map(
      ({
        medication_id,
        medication_name,
        dosage_and_frequency,
        start_date,
        end_date,
        route_id,
        prescribed_by,
        reason_for_use,
        id,
        notes,
        subject_id,
      }) => ({
        medication_id,
        medication_name,
        dosage_and_frequency,
        start_date,
        end_date,
        route_id,
        prescribed_by,
        reason_for_use,
        id,
        notes,
        subject_id,
      })
    );
  }

  return sanitized;
}
